import React from 'react';

export interface HeaderNavItem {
    path: string;
    label: string;
}

interface HeaderNavigationProps {
    items: HeaderNavItem[];
    currentPath: string;
    onNavigate: (path: string) => void;
    isItemActive?: (item: HeaderNavItem, currentPath: string) => boolean;
    className?: string;
    ariaLabel?: string;
}

export const APP_HEADER_NAV_ITEMS: HeaderNavItem[] = [
    { path: '/tasks', label: 'Задачи' },
    { path: '/projects', label: 'Проекты' },
    { path: '/articles', label: 'Статьи' },
    { path: '/chat', label: 'Чат' },
];

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
    items,
    currentPath,
    onNavigate,
    isItemActive,
    className = 'header-nav',
    ariaLabel = 'Основная навигация',
}) => {
    const resolveIsActive = (item: HeaderNavItem) =>
        isItemActive ? isItemActive(item, currentPath) : currentPath === item.path;

    return (
        <nav className={className} aria-label={ariaLabel}>
            {items.map((item) => (
                <button
                    key={item.path}
                    type="button"
                    className={`nav-button ${resolveIsActive(item) ? 'active' : ''}`}
                    onClick={() => onNavigate(item.path)}
                >
                    {item.label}
                </button>
            ))}
        </nav>
    );
};

export default HeaderNavigation;
